export default __webpack_public_path__ + "static/media/BR - Network Analyst.1bed5323.png";